import { useMemo } from "react";
import { useAtomValue } from "jotai";
import { useWatch, type Control } from "react-hook-form";
import {
  dynamicNodeConfigsAtom,
  nodeDataMapAtom,
  nodeRegistryAtom,
} from "@/store/editor-v2";
import {
  resolveBoundObjectFields,
  type BoundObjectField,
} from "./boundShapeSync";

export type { BoundObjectField } from "./boundShapeSync";

// The object_fields of the variable whole-bound into `nodeId.fieldKey`;
// empty for non-whole binds, untyped sources, or outside the V2 editor.
export function useBoundObjectFields(
  control: Control<Record<string, unknown>>,
  nodeId: string | undefined,
  fieldKey: string | undefined
): BoundObjectField[] {
  const path = nodeId && fieldKey ? `${nodeId}.${fieldKey}` : "__unbound__";
  const raw = useWatch({ control, name: path });
  const nodeDataMap = useAtomValue(nodeDataMapAtom);
  const nodeRegistry = useAtomValue(nodeRegistryAtom);
  const dynamicNodeConfigs = useAtomValue(dynamicNodeConfigsAtom);

  return useMemo(() => {
    if (!nodeId || !fieldKey) return [];
    return resolveBoundObjectFields(raw, {
      nodeDataMap,
      nodeRegistry: nodeRegistry ?? [],
      dynamicNodeConfigs,
    });
  }, [raw, nodeId, fieldKey, nodeDataMap, nodeRegistry, dynamicNodeConfigs]);
}
